import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyValueMask',
  standalone: true,
})
export class EmptyValueMaskPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (value) {
      if (typeof value === 'number') {
        return value.toString();
      }
      if (typeof value === 'string') {
        const trimmed = value.toString().trim();
        if (trimmed) {
          return trimmed;
        }
      }
    }
    return '-';
  }
}
